// client/src/components/marketer/result/modals/RejectCompleteModal.js
import React from 'react';
import '../../../../styles/marketer/modals/ResultRejectModals.css';

export default function RejectCompleteModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="result-reject-modal mbm-overlay" onClick={onClose}>
      <div className="result-reject-modal__content mbm" onClick={(e) => e.stopPropagation()}>
        {/* 아이콘 */}
        <div className="result-reject-modal__complete-icon-container">
          <div className="result-reject-modal__complete-icon">📋</div>
        </div>

        {/* 제목 및 설명 */}
        <h2 className="result-reject-modal__complete-title mbm-title">거절 처리 완료</h2>
        <div className="result-reject-modal__complete-description">
          결과물 거절이 완료되었습니다.<br />
          셀프애드 관리자 팀에서 검토를 진행합니다.
        </div>

        {/* 안내 정보 */}
        <div className="result-reject-modal__complete-info-box">
          <div className="result-reject-modal__complete-info-item">
            <div className="result-reject-modal__complete-info-icon">👨‍💼</div>
            <div>
              <div className="result-reject-modal__complete-info-title">관리자 검토 진행</div>
              <div className="result-reject-modal__complete-info-desc">셀프애드 관리자 팀이 거절 사유를 검토하고 있습니다.</div>
            </div>
          </div>
          
          <div className="result-reject-modal__complete-info-item">
            <div className="result-reject-modal__complete-info-icon">⏳</div>
            <div>
              <div className="result-reject-modal__complete-info-title">처리 대기 중</div>
              <div className="result-reject-modal__complete-info-desc">관리자 검토 후 최종 승인 또는 계약 취소 처리됩니다.</div>
            </div>
          </div>
          
          <div className="result-reject-modal__complete-info-item">
            <div className="result-reject-modal__complete-info-icon">📧</div>
            <div>
              <div className="result-reject-modal__complete-info-title">결과 알림</div>
              <div className="result-reject-modal__complete-info-desc">최종 처리 결과는 이메일로 알려드립니다.</div>
            </div>
          </div>
        </div>

        {/* 닫기 버튼 */}
        <div className="mbm-foot">
          <button onClick={onClose} className="result-reject-modal__complete-confirm-button mb-btn mb-btn-primary">
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

